/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { InsightsPanelService } from '@fleetmatics/ui.insights-panel';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NEVER } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { CloseSidePanel } from '../actions';
import {
  ChangeOpenCloseStateSidePanel,
  CloseInsightsPanel,
  InsightsPanelActions,
  OpenInsightsPanel
} from '../actions/insights-panel.actions';

@Injectable()
export class InsightsPanelEffects {
  public openInsightsPanel$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType<OpenInsightsPanel>(InsightsPanelActions.OpenSidePanel),
        tap(() => {
          if (this._insightsService?.tryOpenDrawer) {
            this._insightsService.tryOpenDrawer();
          }
        })
      ),
    { dispatch: false }
  );

  public closeInsightsPanel$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType<CloseInsightsPanel>(InsightsPanelActions.CloseSidePanel),
        tap(() => {
          if (this._insightsService?.closeDrawer) {
            this._insightsService.closeDrawer();
          }
        })
      ),
    { dispatch: false }
  );

  public changeOpenCloseStateSidePanel$ = createEffect(() =>
    this._actions$.pipe(
      ofType<ChangeOpenCloseStateSidePanel>(InsightsPanelActions.ChangeOpenCloseStateSidePanel),
      switchMap(() => {
        if (!this._insightsService) {
          return NEVER;
        }

        if (this._insightsService.isPanelOpen()) {
          this._insightsService.closeDrawer();
          return NEVER;
        }

        this._insightsService?.tryOpenDrawer(true);
        return [new CloseSidePanel()];
      })
    )
  );

  constructor(
    private readonly _actions$: Actions,
    private readonly _insightsService: InsightsPanelService
  ) {}
}
